module.exports = __webpack_public_path__ + "img/6trebol.5c96f40f.png";